export const customSelectStyles = {
    menu: (provided) => ({ ...provided, zIndex: 1000 }),
    control: (provided) => ({ ...provided, minHeight: 24 }),
    valueContainer: (provided) => ({ ...provided, height: 24 }),
    menuList: (provided) => ({ ...provided, paddingTop: 0, paddingBottom: 0 }),
};
